var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      medium: !_vm.isUser
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u(
      [
        _vm.isUser
          ? {
              key: "input",
              fn: function() {
                return [
                  _c("v-text-field", {
                    attrs: {
                      id: "user_name",
                      label: _vm.$t("userName"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.user.name,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "name", $$v)
                      },
                      expression: "user.name"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-radio-group",
                    {
                      model: {
                        value: _vm.status,
                        callback: function($$v) {
                          _vm.status = $$v
                        },
                        expression: "status"
                      }
                    },
                    [
                      _vm._l(3, function(n) {
                        return _c("v-radio", {
                          key: n,
                          attrs: {
                            label: "" + _vm.radioLabel[n - 1],
                            value: n,
                            disabled: _vm.status === -1
                          }
                        })
                      }),
                      _vm._v(" "),
                      _c("v-radio", {
                        attrs: {
                          label: _vm.$t("unsubscribed"),
                          value: -1,
                          disabled: ""
                        }
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("v-autocomplete", {
                    attrs: {
                      clearable: "",
                      label: _vm.$t("groups"),
                      multiple: "",
                      chips: "",
                      "deletable-chips": "",
                      "item-text": "name",
                      "item-value": "groupKey",
                      items: _vm.groups
                    },
                    model: {
                      value: _vm.groupKeys,
                      callback: function($$v) {
                        _vm.groupKeys = $$v
                      },
                      expression: "groupKeys"
                    }
                  })
                ]
              },
              proxy: true
            }
          : {
              key: "input",
              fn: function() {
                return [
                  _c("v-text-field", {
                    attrs: { id: "groupName", label: _vm.$t("groupName") },
                    model: {
                      value: _vm.groupInEdit.name,
                      callback: function($$v) {
                        _vm.$set(_vm.groupInEdit, "name", $$v)
                      },
                      expression: "groupInEdit.name"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.allUsers,
                      label: _vm.$t("selectedUsers"),
                      "item-text": "name",
                      "item-value": "uid",
                      "return-object": "",
                      multiple: "",
                      chips: "",
                      "deletable-chips": ""
                    },
                    model: {
                      value: _vm.groupMember,
                      callback: function($$v) {
                        _vm.groupMember = $$v
                      },
                      expression: "groupMember"
                    }
                  })
                ]
              },
              proxy: true
            }
      ],
      null,
      true
    ),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b4627f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b4627f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MemberEdit.vue
// module id = null
// module chunks = 